import DOMPurify from "dompurify";

// Narrow allowlist — keeps body_html email-template friendly.
// Sanitization runs on save (defense-in-depth; authors are trusted admins).
const ALLOWED_TAGS = [
  "p", "br", "strong", "em", "a", "h2", "h3",
  "ul", "ol", "li", "blockquote", "hr", "img",
];

const ALLOWED_ATTR = ["href", "target", "rel", "src", "alt"];

export function sanitizePostHtml(html: string): string {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
  });
  // Force safe link attributes on any external <a target="_blank">
  return clean.replace(
    /<a ([^>]*?)target="_blank"([^>]*?)>/gi,
    (_m, pre, post) =>
      /rel=/i.test(pre + post)
        ? `<a ${pre}target="_blank"${post}>`
        : `<a ${pre}target="_blank" rel="noopener noreferrer"${post}>`,
  );
}
